/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name rlog
   * @description
   *
   */
  angular
    .module('vcutils.rlog', [
      'ui.router',
      'knalli.angular-vertxbus'
    ]);
}());
